export function quotaListConfig(getMoney, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: true,
    searchShow: false,
    column: [{
        label: "客户名称",
        placeholder: "请输入客户名称",
        search: true,
        slot: true,
        prop: "blCustName",
        width: "180",
        overHidden: true
      }, {
        label: "融资额度（元）",
        prop: "financingQuota",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: "已用额度（元）",
        prop: "usedFinancingQuota",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: "可用额度（元）",
        prop: "usableFinancingQuota",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: "是否循环授信",
        width: "120",
        prop: "isLoopCredit",
        formatter: (row, value, label, column) => {
          return value == 0 ? '否' : '是';
        }
      }, {
        label: "是否集团授信",
        width: "120",
        prop: "isGroupCredit",
        formatter: (row, value, label, column) => {
          return value == 1 ? '是' : '否';
        }
      },
      // {
      //     label: "业务部门",
      //     width: "120",
      //     prop: "managerDeptName",
      //     overHidden: true,
      //     search: true,
      //     hide: true,
      //     click: () => {
      //         selectDeptClick();
      //     }
      // },
      {
        label: "业务经理",
        width: "120",
        prop: "managerUserName",
        overHidden: true,
        search: true,
        searchClearable: false,
        click: () => {
          selectPersonClick();
        }
      }, {
        label: "所属部门",
        prop: "managerDeptName",
        overHidden: true,
        width: "150"
      }, {
        label: "状态",
        prop: "quotaStatus",
        width: '80',
        slot: true
      }, {
        label: "更新时间",
        prop: "updateTime",
        overHidden: true,
        search: true,
        type: "daterange"
      }
    ]
  }
}

export function filterConfig(selectPersonClick, selectDeptClick) {
  return {
    column: [{
        label: "客户名称",
        placeholder: "请输入客户名称",
        prop: "sellerCustName"
      }, {
        label: "融资额度",
        placeholder: "请输入客户名称",
        prop: "factoringCredit",
        formslot: true
      }, {
        label: "业务经理",
        placeholder: "请选择业务经理",
        width: "120",
        prop: "managerUserName",
        click: () => {
          selectPersonClick();
        }
      }, {
        label: "所属部门",
        placeholder: "请选择部门",
        prop: "managerDeptName",
        width: "150",
        click: () => {
          selectDeptClick();
        }
      }, {
        label: "更新时间",
        type: "daterange",
        placeholder: "请选择时间",
        prop: "updateTimeRange",
        overHidden: true,
        width: "150"
      }, {
        label: "状态",
        type: "select",
        prop: "quotaStatus",
        dicData: [{
            value: 0,
            name: "失效"
          },
          {
            value: 1,
            name: "生效"
          }
        ]
      }

    ]
  }
}

export function presentQuotaInfoConfig() {
  return [{
    name: '融资额度',
    prop: 'financingQuotaStr'
  }, {
    name: '授信状态',
    prop: 'statusStr'
  }, {
    name: '起始日期',
    prop: 'startDate'
  }, {
    name: '到期日期',
    prop: 'endDate'
  }, {
    name: '是否集团授信',
    prop: 'isGroupCreditStr'
  }, {
    name: '循环授信',
    prop: 'isLoopCreditStr'
  }, {
    name: '创建时间',
    prop: 'createTime'
  }]
}

export function quotaDetailListConfig(getMoney) {
  return {
    refreshBtn: false,
    menu: false,
    addBtn: false,
    showLoading: false,
    showCard: false,
    showBorder: false,
    showStripe: false,
    showHeader: true,
    showIndex: true,
    showCheckbox: false,
    columnBtn: false,
    searchBtn: true,
    submitBtn: false,
    emptyBtn: false,
    align: 'center',
    index: true,
    indexLabel: "序号",
    column: [{
        label: '项目名称',
        prop: 'name'
      },
      {
        label: '融资合同编号',
        prop: 'contractName'
      },
      {
        label: '记录类型',
        prop: 'quotaType',
        formatter: (row, value, label, column) => {
          return value == 1 ? '占用' : value == 2 ? '恢复' : '';
        }
      },
      {
        label: '发生额度（元）',
        prop: 'money',
        slot: true,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
      {
        label: '发生时间',
        prop: 'writeoffTime'
      },
      {
        label: '备注',
        prop: 'remark'
      }
    ]
  }
}

export function creditHistoryConfig(getMoney) {
  return {
    refreshBtn: false,
    menu: false,
    addBtn: false,
    showLoading: false,
    showCard: false,
    showBorder: false,
    showStripe: false,
    showCheckbox: false,
    columnBtn: false,
    submitBtn: false,
    emptyBtn: false,
    align: 'center',
    index: true,
    indexLabel: "序号",
    column: [{
        label: '项目名称',
        prop: 'name',
        width: '200',
        overHidden: true
      },
      {
        label: '是否集团授信',
        prop: "isGroupCredit",
        formatter: (row, value, label, column) => {
          return value == 1 ? '是' : '否';
        }
      },
      {
        label: '融资额度（元）',
        prop: "financingQuota",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
      {
        label: '起始日期',
        prop: 'startDate'
      },
      {
        label: '到期日期',
        prop: 'endDate'
      },
      {
        label: '创建时间',
        prop: 'createTime'
      },
      {
        label: '循环授信',
        prop: "isLoopCredit",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=factoring_loop_credit",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
      },
      {
        label: '状态',
        prop: "quotaStatus",
        width: '80',
        slot: true
      }
    ]
  }
}

export function highchartsQuotaConfig() {
  return {
    chart: {
      type: 'pie',
      options3d: {
        enabled: true,
        alpha: 45,
        beta: 0
      }
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        depth: 35,
        dataLabels: {
          enabled: true,
          format: '{point.name}'
        }
      }
    },
    series: [{
      type: 'pie',
      name: '占比',
      data: [{
          name: '已用额度',
          y: 0,
          color: '#ff8e9d'
        },
        {
          name: '可用额度',
          y: 0,
          color: '#45d8d9',
          sliced: true,
          selected: true
        }
      ]
    }]
  }
}
